import BaseModelFactory from './base.factory'
import UserTermService from './../services/UserTerm.service'
const getUserTermModel = () => require('./../models/user-term.model').default

class UserTermFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UserTermService, Model: getUserTermModel() }
    )

  static findAllByUserId = async userId =>
    await this._findBy({ user_id: userId }, { Service: UserTermService, Model: getUserTermModel() })

  static create = payload =>
    this._create(payload, {
      Service: UserTermService,
      Model: getUserTermModel(),
    })
}

export default UserTermFactory
